import React, { Component } from 'react';

class Resume extends Component {
  render() {
    if (!this.props.data) return null;

    const { skillmessage, education, work, skills } = this.props.data;

    return (
      <section id="resume">
        <div className="container">
          <h1>Resume</h1>

          {/* Education Section */}
          <div className="resume-section">
            <h2>Education</h2>
            <div className="timeline">
              {education &&
                education.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <h3>{item.school}</h3>
                    <p className="info">
                      {item.degree} <span>•</span>{' '}
                      <em className="date">{item.graduated}</em>
                    </p>
                    <p>{item.description}</p>
                  </div>
                ))}
            </div>
          </div>

          {/* Work Experience Section */}
          <div className="resume-section">
            <h2>Work Experience</h2>
            <div className="timeline">
              {work &&
                work.map((item, index) => (
                  <div key={index} className="timeline-item">
                    <h3>{item.company}</h3>
                    <p className="info">
                      {item.title} <span>•</span>{' '}
                      <em className="date">{item.years}</em>
                    </p>
                    {item.responsibilities ? (
                      <ul className="responsibilities">
                        {item.responsibilities.map((responsibility, idx) => (
                          <li key={idx}>{responsibility}</li>
                        ))}
                      </ul>
                    ) : (
                      <p>{item.description}</p>
                    )}
                  </div>
                ))}
            </div>
          </div>

          {/* Skills Section */}
          <div className="resume-section">
            <h2>Technical Skills</h2>
            <p style={{ color: 'var(--text-secondary)', marginBottom: '2rem' }}>
              {skillmessage}
            </p>
            <div className="skills-grid">
              {skills &&
                skills.map((skill, index) => (
                  <div key={index} className="skill-card">
                    <h4>{skill.name}</h4>
                    <div className="skill-bar">
                      <div
                        className="skill-progress"
                        style={{ width: skill.level }}
                      ></div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Resume;
